import React, { createContext, useContext, useState } from "react";
import { WeddingLanguage } from "../../components/Wedding/content";

const InvitationLanguageContext = createContext<{
  language: WeddingLanguage;
  setLanguage: (language: WeddingLanguage) => void;
}>({ language: "en", setLanguage: () => {} });

export function InvitationLanguageProvider({ children }: { children: React.ReactNode }) {
  const [language, setLanguage] = useState<WeddingLanguage>("en");
  return <InvitationLanguageContext.Provider value={{ language, setLanguage }}>{children}</InvitationLanguageContext.Provider>;
}

export function useInvitationLanguage() {
  const context = useContext(InvitationLanguageContext);
  return { ...context, t: (en: string, vi: string) => context.language === "vi" ? vi : en };
}

export function InvitationLanguageSwitcher() {
  const { language, setLanguage } = useInvitationLanguage();
  return (
    <nav className="invitation-language" aria-label="Language / Ngôn ngữ">
      <button type="button" lang="en" aria-label="English" aria-pressed={language === "en"} onClick={() => setLanguage("en")}>EN</button>
      <span aria-hidden="true">/</span>
      <button type="button" lang="vi" aria-label="Tiếng Việt" aria-pressed={language === "vi"} onClick={() => setLanguage("vi")}>VI</button>
    </nav>
  );
}
